import { cols } from "@/config/system";
import { momentFormat } from "@/utils/formatter";

export const tableColumn = [
  {
    label: "对账客户名称",
    prop: "customerName",
  },
  {
    label: "对账项目客户",
    prop: "contractProjectName",
  },
  {
    label: "网点名称",
    prop: "siteName",
  },
  {
    label: "结款周期",
    prop: "accountCycleShow",
    width: cols.op1,
  },
  {
    label: "账单日期",
    prop: "billPeriodDateTime",
  },
  {
    label: "发件票数",
    prop: "billCount",
    width: cols.op1,
  },
  {
    label: "结算重量",
    prop: "accountWeight",
    width: cols.op1,
  },
  {
    label: "运费",
    prop: "tranFee",
    width: cols.mini,
  },
  {
    label: "理赔费用",
    prop: "claimsFee",
    width: cols.op1,
  },
  {
    label: "加收费用",
    prop: "claimsAddFee",
    width: cols.op1,
  },
  {
    label: "跨期结算费用",
    prop: "crossSettlementFee",
    width: cols.op2,
  },
  {
    label: "应付总额",
    prop: "totalFee",
    width: cols.op1,
  },
  {
    label: "已付/预付金额",
    prop: "hexiaoFee",
    width: cols.op2,
  },
  {
    label: "未付金额",
    prop: "expensesFee",
    width: cols.op1,
  },
];
